<!-- @format -->
<!-- Migrated from AngularJS: plans.tpl.html -->
<!--
  The container wrapping was on the parent state's template string in the original
  tutoring.route.js (`<div class="container"><plans .../></div>`). UI Router's
  `component:` route field has no equivalent wrapping slot, so the container moves
  inside this template; children rendered via `<ui-view>` below still inherit it.
-->
<div class="container">
  @if (plans.length === 0) {
    <div>
      <div class="no-plans">{{ "SIS_COMPONENTS.PLAN.NO_PLANS" | translate }}</div>
    </div>
  }
  @if (plans.length > 0) {
    <div class="row">
      <div class="col-12">
        <div class="page-title-container">
          <div class="plan-title">
            <div class="plan-header">
              <app-my-plan-select></app-my-plan-select>
            </div>
            <div class="buttons float-end">
              <!--
              tutor.logged-in.student.* states are used by the tutor app and student.* states only by the student
              app. Some links here are unreachable from the student build because this template is one of a pair
              with frontend-tutor/**/plan.tpl.html — they were kept in lockstep so the files stay identical. The
              tutor-side branches can be dropped once the tutor app stops sharing this shell.
            -->

              @if (state.is("tutor.logged-in.student.student.tutoring.plans.plan.structure")) {
                <a uiSref="tutor.logged-in.student.student.tutoring.plans.plan.printPlan" class="btn btn-secondary btn-sm anchor-button">
                  <span>{{ "SIS_COMPONENTS.PLAN.GO_TO_PRINT_VIEW" | translate }}</span>
                </a>
              }

              @if (state.is("student.logged-in.plan.tutoring.messages")) {
                <!-- old student view -->
                <a
                  uiSref="student.logged-in.structure"
                  [uiParams]="{ planId: selectedPlan?.id }"
                  class="btn btn-secondary btn-hollow btn-sm anchor-button navigate-back"
                  role="button"
                  [attr.aria-label]="'ARIA_LABEL.RETURN_TO_PLAN' | translate">
                  <sis-icon icon="chevron" [iconClass]="'flip-180'"></sis-icon>
                  <span>{{ "SIS_COMPONENTS.PLAN.BACK_TO_PLAN" | translate }}</span>
                </a>
              }

              @if (state.is("student.logged-in.plan.tutoring.new-messages")) {
                <!-- new student view -->
                <a
                  uiSref="student.logged-in.new-plan.structure"
                  [uiParams]="{ planId: selectedPlan?.id }"
                  class="btn btn-secondary btn-hollow btn-sm anchor-button navigate-back"
                  role="button"
                  [attr.aria-label]="'ARIA_LABEL.RETURN_TO_PLAN' | translate">
                  <sis-icon icon="chevron" [iconClass]="'flip-180'"></sis-icon>
                  <span>{{ "SIS_COMPONENTS.PLAN.BACK_TO_PLAN" | translate }}</span>
                </a>
              }

              @if (state.is("tutor.logged-in.student.student.tutoring.plans.plan.structure")) {
                <a
                  uiSref="tutor.logged-in.student.student.tutoring.plans.plan.messages"
                  [uiParams]="{ planId: selectedPlan?.id }"
                  role="button"
                  class="btn btn-secondary btn-hollow btn-sm anchor-button">
                  {{ "SIS_COMPONENTS.PLAN.SHOW_MESSAGES.TUTOR" | translate }}
                </a>
              }

              @if (state.is("student.logged-in.plan.tutoring")) {
                <a
                  uiSref="student.logged-in.structure"
                  [uiParams]="{ planId: selectedPlan?.id }"
                  class="btn btn-secondary btn-hollow btn-sm anchor-button navigate-back"
                  role="button"
                  [attr.aria-label]="'ARIA_LABEL.RETURN_TO_PLAN' | translate">
                  <sis-icon icon="chevron" [iconClass]="'flip-180'"></sis-icon>
                  <span>{{ "SIS_COMPONENTS.PLAN.BACK_TO_PLAN" | translate }}</span>
                </a>
              }

              @if (
                !state.is("tutor.logged-in.student.student.tutoring.plans.plan.structure") &&
                !state.is("student.logged-in.plan.tutoring.messages") &&
                !state.is("student.logged-in.plan.tutoring.new-messages") &&
                !state.is("student.logged-in.plan.tutoring")
              ) {
                <a
                  uiSref="tutor.logged-in.student.student.tutoring.plans.plan.structure"
                  [uiParams]="{ planId: selectedPlan?.id }"
                  role="button"
                  class="btn btn-secondary btn-hollow btn-sm anchor-button navigate-back"
                  [attr.aria-label]="'ARIA_LABEL.RETURN_TO_PLAN' | translate">
                  <sis-icon icon="chevron" [iconClass]="'flip-180'"></sis-icon>
                  <span>{{ "SIS_COMPONENTS.PLAN.BACK_TO_PLAN" | translate }}</span>
                </a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <ui-view></ui-view>
      </div>
    </div>
  }
</div>
